<template lang="">
    <div>
        <v-card>
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12"  class="mb-0 pb-0">
                        Revisi&oacute;n | Seleccionar Pregunta
                    </v-col>
                    <v-col cols="12" sm="12" md="12" class="mt-0 pt-0">
                            <small class="text-h6 font-italic light-blue--text darken-3--text" v-if="nombreMunicipio">{{nombreMunicipio}}</small>
                    </v-col>


                    <v-col cols="12" sm="12" md="12">
                        <v-select
                            v-model="boletaSeleccionadaId"
                            :items="boletas"
                            :loading="ddBoletasLoading"
                            dense
                            outlined
                            label="Seleccionar Boleta/Índice"
                            item-text="nombreIndice"
                            item-value="id"
                            return-object
                            :hint="boletaSeleccionadaId.id<=0 ? 'Debe seleccionar una boleta' : ''"
                            :no-data-text="boletas ? 'Selecciona un índice' : 'No se han registrado índices'"
                            @change="obtenerPreguntasAsignadas"
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-row no-gutters align="center">
                                        <span>{{ item.nombreIndice }}</span>
                                        <!--<v-spacer></v-spacer>
                                        <v-chip text-color="white" :color="item.estadosBoletaId==3 ? 'green' : 'orange'" small
                                        >{{ item.estadoBoleta }}</v-chip>-->
                                 </v-row>
                            </template>
                            <template v-slot:item="{ item, attrs, on }">
                                <v-list-item v-on="on" v-bind="attrs">
                                    <v-list-item-content>
                                    <v-list-item-title>
                                        <v-row no-gutters align="center">
                                        <span>{{ item.nombreIndice }}</span>
                                        <v-spacer></v-spacer>
                                        <v-chip text-color="white" :color="item.estadosBoletaId==3 || item.estadosBoletaId==6  ? 'teal' : 'orange'" small
                                        >{{ item.estadoBoleta }}</v-chip>
                                        </v-row>
                                    </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>

            <v-card-text>

                <v-data-table
                        :headers="headers"
                        :items="preguntas"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="tableFilter"
                        :items-per-page="10"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                        
                    >


                    <template v-slot:item="{ item }">
                        <tr>
                            
                            <td>{{ item.noOrdenPregunta }}</td>
                            <td>{{ item.indice }}</td>
                            <td>{{ item.textoPregunta }}</td>
                            <td>
                                <v-btn class="ma-2" 
                                    small tile outlined 
                                    color="indigo"
                                    @click="obtenerEstructuraPregunta(item.boletaMuniId, item.preguntaId, item.visitaCampo)"
                                >
                                    <v-icon left>mdi-check</v-icon> Seleccionar
                                </v-btn>
                            </td>
                        </tr>

                        <tr div v-for="subpregunta in item.subPreguntaN1" :key="'S' + subpregunta.preguntaId">

                                <td></td>
                                <td></td>
                                <td>
                                    <v-row>
                                        <v-col md="1" sm="1" xs="1"></v-col>
                                        <v-col md="11" sm="11" xs="11">{{ item.noOrdenPregunta }}.{{ subpregunta.noOrdenPregunta }} {{ subpregunta.textoPregunta }} </v-col>
                                    </v-row>
                                </td>
                                <td>
                                <v-btn class="ma-2" 
                                    small tile outlined 
                                    color="indigo"
                                    @click="obtenerEstructuraPregunta(subpregunta.boletaMuniId, subpregunta.preguntaId, item.visitacampo)"
                                >
                                    <v-icon left>mdi-check</v-icon> Seleccionar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>


        </v-card>
        <!-- Fin:: v-card-->


        <!-- Inicio:: Dialog para mostrar la pregunta con sus respuestas-->
        <v-dialog
            v-model="dialogRevisar"
            fullscreen
            persistent 
            transition="dialog-bottom-transition"
            
        >
            
            <v-card scrollable>
                <v-card-title>
                   
                    <v-row class="col-md-10">
                        <v-col cols="12" sm="12" md="12"  class="mb-0 pb-0">
                             Revisar pregunta | <small class="text-h6" v-if="nombreMunicipio">{{nombreMunicipio}}</small>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-0 pt-0">
                                <small class="text-h6" v-if="boletaSeleccionadaId.nombreIndice">{{boletaSeleccionadaId.nombreIndice}}</small>
                        </v-col>
                    </v-row>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        :disabled="btnRegistroLoading"
                        @click="dialogRevisar=false;"
                        class="float-right"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    
                   
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12">
                            <h4 class="text-h6">{{textoPregunta}}</h4>
                        </v-col>
                        
                        <v-col cols="12" md="6" sm="6" xs="12">
                             <SubHeader subHeaderTitle="Respuestas " />

                             <!--Mostrar respuestas de la pregunta seleccionada-->
                             <v-data-table
                                :items="respuestasPreguntaSeleccionada"
                                item-key="Id"
                                :headers="respuestasHeaders"
                                class="elevation-0"
                                :loading="tableLoading"
                                no-data-text="No hay datos para mostrar"
                                :items-per-page="50"
                                hide-default-footer
                                
                            >

                                <template v-slot:item="{ item }">
                                    <tr @click="respuestasRowClick(item)"  :class="{'selectedRow': item === selectedItem}" class="hoverRow">
                                        <!--<td>{{ item.id }}</td>-->
                                        <td>{{ item.textoRespuesta }}</td>
                                        <td>{{ item.valor.length > 0 ? item.tipoDatoId == 6 && item.valor[0].respuesta == '2' ? '0': item.valor[0].respuesta  : 'Sin responder' }}</td>
                                    </tr>
                                </template>

                            </v-data-table>

                            <v-divider>
                            </v-divider>


                            <SubHeader v-if="mediosPreguntaAsignados.length>0" subHeaderTitle="Medios de verificación " />
                            <div v-for="medio in mediosPreguntaAsignados" :key="medio.id">
                                <v-row>
                                    <v-col cols="12">
                                        <v-tooltip bottom style="z-index: 9999 !important;">
                                            <template v-slot:activator="{ on, attrs }">
                                                <label v-bind="attrs" v-on="on" class="text-subtitle-1 font-weight-regular" style="letter-spacing:0 !important;">{{`${medio.codigo} | ${medio.nombre}`}}</label>
                                            </template>
                                            <span class="text-h6">{{medio.descripcion}}</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                                 <v-row>
                                    <v-col cols="12" class="pt-0 mt-0"  v-if="mediosPregunta[medio.medioVerificacionId]">

                                        <v-btn class="ma-2" tile outlined color="indigo"
                                            @click="descargarArchivo(`${baseIntUrl}${mediosPregunta[medio.medioVerificacionId]}`)">
                                            <v-icon left>mdi-cloud-download</v-icon> Descargar Medio
                                        </v-btn>
                                     </v-col>
                                     <v-col cols="12" class="pt-0 mt-0"  v-else>
                                        <v-alert
                                            outlined
                                            type="warning"
                                            text
                                            dense
                                            >
                                            No se ha cargado el medio de verificación
                                        </v-alert>
                                    </v-col>
                                </v-row>
                                <v-divider class="mb-4 mt-4"></v-divider>
                            </div>
                            

                        </v-col>
                        
                        <v-col cols="1" md="1" sm="1" xs="1" class="text-center">
                            <v-divider
                                vertical
                            ></v-divider>
                        </v-col>
                        

                        <v-col cols="12" md="5" sm="5" xs="12" v-if="datosRevision.boletaMunicipalidadId > 0">
                            <SubHeader subHeaderTitle="Datos del revisor " />

                            <!--Mostrar historial de revisiones de la pregunta seleccionada-->
                             <v-data-table
                                :items="historialRevisiones"
                                item-key="Id"
                                :headers="revisionesHeaders"
                                class="elevation-0"
                                :loading="tableRevisionesLoading"
                                no-data-text="No hay datos para mostrar"
                                :items-per-page="50"
                                hide-default-footer
                                
                            >

                                <template v-slot:item="{ item }">
                                    <tr :class="item.estadosId ===1 && (item.estadosRevisionAprobacionId === 1 || item.estadosAprobacionId===1) ? 'current' : item.estadosId ===1 && (item.estadosRevisionAprobacionId === 2 || item.estadosAprobacionId===2)  ? 'current-desaprobado' : ''">
                                        <!--<td>{{ item.id }}</td>-->
                                        <td>{{ item.fechaCreacion | formatDate }}</td>
                                        <td>{{  item.estadosRevisionAprobacion ? 'Revisión': item.estadoAprobacion ? 'Aprobación'  : '' }}</td>
                                        <td>{{ item.estadosRevisionAprobacion ? item.estadosRevisionAprobacion : item.estadoAprobacion ?  item.estadoAprobacion : '' }}</td>
                                        <td>{{ item.descripcionInconsistencia }}</td>
                                    </tr>
                                </template>

                            </v-data-table>

                            <div v-if="agregarRevision">
                                <SubHeader subHeaderTitle="Registrar Revisión " />
                                <v-form
                                    ref="form"
                                    v-on:submit.prevent="registrarRevision"
                                    v-model="validForm"
                                    >

                                    <v-row class="mt-2">
                                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                                            <v-select
                                                v-model="datosRevision.estadosRevisionAprobacionId"
                                                :items="estadosRevision"
                                                :disabled="!agregarRevision"
                                                dense
                                                outlined
                                                class="required"
                                                label="Seleccionar Estado"
                                                item-text="nombre"
                                                item-value="id"
                                                :no-data-text="estadosRevision!=null ? 'Selecciona una sub pregunta' : 'No se han encontrado estados para asignar, verifique con un administrador'"
                                                :rules="[selectRequired('estado')]"
                                            ></v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row v-if="datosRevision.estadosRevisionAprobacionId===2">
                                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                                            <v-textarea
                                                outlined
                                                counter="1000"
                                                autocomplete="off"
                                                :class="datosRevision.estadosRevisionAprobacionId==2 ? 'required' : ''"
                                                dense
                                                rows="7"
                                                v-model="datosRevision.descripcionInconsistencia"
                                                label="Descripción de la inconsistencia"
                                                :rules="[
                                                    datosRevision.estadosRevisionAprobacionId==2 ? required('Descripción') : true,
                                                    maxLength('Descripción', 1000),
                                                ]"
                                                maxlength="1000"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-btn
                                            color="primary"
                                            class="mb-2 float-right"
                                            type="submit"
                                            :elevation="0" 
                                            :disabled="!validForm" 
                                            :loading="btnRegistroLoading"                         
                                        >
                                            Guardar
                                        </v-btn>
                                    </v-row>

                                </v-form>

                            </div>

                            <div v-if="!agregarRevision" class="mt-6">
                                <v-alert
                                    outlined
                                    type="success"
                                    text
                                    dense
                                    >
                                    La respuesta se encuentra en estado "APROBADO"
                                </v-alert>
                            </div>
                                

                        </v-col>
                        
                    </v-row>

                    <v-row v-if="tieneVisitaCampo">
                        <v-col cols="12" md="12" sm="12" xs="12" class="text-center">
                            <v-divider
                            ></v-divider>
                        </v-col>

                            <v-col cols="12" md="12" sm="12" xs="12">
                                <SubHeader subHeaderTitle="Visita de campo" />
                                <span class="text-h6">Medio de verificación para la visita de campo</span>
                            </v-col>

                            <v-container fluid style="background: #efefef; padding: 15px; border: 1px solid #ccc; border-radius: 5px;">  
                                <v-row>    
                                    <v-col cols="12" md="12" v-if="visitaCampoRegistrada">
                                        <v-alert
                                            outlined
                                            type="success"
                                            text
                                            dense
                                            >
                                            Ya se ha cargado el medio de verificación de visita de campo, puede descargarlo o reemplezarlo
                                        </v-alert>
                                        

                                        
                                    </v-col>

                                    <v-col cols="12" md="3" sm="6" xs="12">
                                        <span class="text-subtitle-1 font-weight-medium">DIRECCIÓN</span>
                                        <p class="text-body-1">{{datosVisitaCampo.direccion}}</p>
                                    </v-col>

                                    <v-col cols="12" md="3" sm="6" xs="12">
                                        <span class="text-subtitle-1 font-weight-medium">LATITUD</span>
                                        <p class="text-body-1">{{datosVisitaCampo.latitud}}</p>
                                    </v-col>

                                    <v-col cols="12" md="3" sm="6" xs="12">
                                        <span class="text-subtitle-1 font-weight-medium">LONGITUD </span>
                                        <p class="text-body-1">{{datosVisitaCampo.longitud}}</p>
                                    </v-col>

                                    <v-col cols="12" md="3" sm="6" xs="12">
                                        <v-btn class="ma-2" tile outlined color="indigo"
                                            @click="descargarArchivo(`${baseIntUrl}${datosVisitaCampo.path}`)">
                                            <v-icon left>mdi-cloud-download</v-icon> Descargar Medio
                                        </v-btn>

                                    </v-col>

                                </v-row>
                            </v-container>

                        <v-form
                            ref="form"
                            v-on:submit.prevent="guardarMedio()"
                            v-model="validFormMedio"
                            >
                            <v-container>

                                <v-col cols="12" md="12" sm="12" xs="12">
                                    <span v-if="visitaCampoRegistrada" class="text-h6">Actualizar medio</span>
                                    <span v-if="!visitaCampoRegistrada" class="text-h6">Registrar medio</span>
                                    <v-divider></v-divider>
                                </v-col>

                                <v-row>
                                    <v-col cols="12" md="6" sm="6" class="pt-0">
                                        <v-file-input
                                            :id="`mvFile`"
                                            :ref="`mvFile`"
                                            accept="application/pdf,image/jpeg"
                                            append-icon="mdi-file-pdf-outline"
                                            dense
                                            v-model="archivoVisitaMV"
                                            hint="Selecciona un archivo jpg o pdf para el medio de verificación. Peso máximo 25Mb"
                                            label="Seleccionar archivo"
                                            outlined
                                            prepend-icon=""
                                            @change="onFileChange($event, `mvFile`)"
                                            :show-size="1000">
                                            <template v-slot:selection="{ index, text }">
                                                    <v-chip
                                                        v-if="index < 2"
                                                        small
                                                        label
                                                        :color="archivoVisitaMVValido ? 'primary' : 'error'"
                                                    >
                                                        {{ text }}
                                                    </v-chip>
                                                    <span
                                                        v-else-if="index === 2"
                                                        class="text-overline grey--text text--darken-3 mx-2"
                                                    >
                                                        +{{ files.length - 2 }} archivo(s)
                                                    </span>
                                                </template>
                                        </v-file-input>
                                    </v-col>
                                
                                    <v-col  cols="12" md="6" sm="6" class="pt-0 text-left">
                                        <v-text-field
                                            outlined
                                            counter="200"
                                            autocomplete="off"
                                            class="required"
                                            dense
                                            v-model="datosVisita.direccion"
                                            label="Dirección"
                                            :rules="[
                                                required('dirección')
                                            ]"
                                            maxlength="200"
                                        ></v-text-field>
                                    </v-col>
                                
                                    <v-col  cols="6" md="6" sm="12" class="pt-0 text-left">
                                        <v-text-field
                                            outlined
                                            counter="150"
                                            autocomplete="off"
                                            dense
                                            v-model="datosVisita.latitud"
                                            label="Latitud"
                                            maxlength="150"
                                        ></v-text-field>
                                    </v-col>
                                
                                    <v-col  cols="6" md="6" sm="12" class="pt-0 text-left">
                                        <v-text-field
                                            outlined
                                            counter="150"
                                            autocomplete="off"
                                            dense
                                            v-model="datosVisita.longitud"
                                            label="Longitud"
                                            maxlength="150"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col  cols="12" md="4" sm="4" class="pt-0 text-left">
                                        <v-btn color="blue-grey" class="white--text"  :disabled="!validFormMedio"
                                        type="submit"
                                            >
                                            <!--<v-icon left>mdi-cloud-upload</v-icon> {{mediosPregunta[medioVerificacion.medioVerificacionId] ? 'Cargar de nuevo' : 'Cargar MV'}}-->
                                            Guardar MV de visita
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-row>
                   

                </v-card-text>
            </v-card>
            <!--Fin:: v-card -->
        
        </v-dialog>
        <!-- Fin:: Dialog para mostrar la pregunta con sus respuestas-->





         <!--Dialog loader -->
        <dialog-loader
            :dialogVisible="dialogLoaderVisible"
            :text="dialogLoaderText"
        ></dialog-loader>
        <!---->

        <!--Inicio:: Snack alert-->
        <SnackAlert ref="snackalert"></SnackAlert>
        <!-- Fin:: Snack alert-->
        
    </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from "vuex";


import moment from "moment";

import validations from "@/core/untils/validations.js";
import { API_BASE_URL } from "@/core/services/api.service";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
import SubHeader from "@/view/components/subheader/SubHeader";

//


import { OBTENER_MUNICIPIO } from "@/core/services/store/catalogos/municipio.module";
import { OBTENER_BOLETAS_POR_MUNI_REVISOR_PERIODO } from "@/core/services/store/boletas/boletamuni.module";
import {OBTENER_PREGUNTAS_POR_MUNICIPIO_PERIODO_INSTITUCION_REVISORA, OBTENER_PREGUNTA_POR_MUNICIPIO_PERIODO} from "@/core/services/store/preguntasperiodoboleta/preguntaperiodoboleta.module";
import {OBTENER_HISTORIAL_REVISIONES_RESPUESTA, REGISTRAR_HISTORIAL_REVISION_RESPUESTA} from "@/core/services/store/revisionaprobacion/revisionaprobacion.module";

import { OBTENER_MEDIOS_VERIFICACION_PREGUNTA_ESPECIFICA_MUNI } from "@/core/services/store/respuestasmuni/medioverificacionmuni.module";


import { CARGAR_ARCHIVO } from "@/core/services/store/cargaarchivo.module";
import { OBTENER_VISITA_CAMPO_PREGUNTA, REGISTRAR_VISITA_CAMPO_PREGUNTA } from "@/core/services/store/visitacampo/visitacampo.module";

moment.locale('es');
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});

export default {
    name: "SeleccionarPreguntasMuni",
    components: {
        SnackAlert,
        SubHeader,
        DialogLoader
    },
     data(){ 
        return{
            nombreMunicipio: null,
            baseIntUrl:'',
            tableLoading:false,
            tableRevisionesLoading:false,
            tableRevisionLoading:false,
            validForm:false,
            parameters:[],
            periodoId:0,
            municipioId:0,
            institucionId:0,
            boletas:[],
            boletaSeleccionadaId:[],
            ddBoletasLoading:false,
            preguntas:[],
            respuestasPreguntaSeleccionada:[],
            respuestaSeleccionada:0,
            preguntaSeleccionadaId:0,
            revisiones: [],
            datosRevision: {
                estadosRevisionAprobacionId:0,
                descripcionInconsistencia: '',
                noRevision: 0,
                respuestasMuniId: 0,
                boletaMunicipalidadId:0,
                estadosId: 1,
            },
            agregarRevision: true,
            historialRevisiones:[],
            estadosRevision:[{id:1, nombre: 'Sin inconsistencia'}, {id: 2, nombre: 'Con inconsistencia'}],
            tableFilter:'',
            selectedItem: null,

            //Medios verificacion
            mediosLoading:false,
            mediosPreguntaAsignados:[],
            mediosPregunta:[],
             mediosAsignados: [],
            visitaCampoRegistrada:false,
            datosVisitaCampo:[],
            validFormMedio:false,
            datosVisita: {
                id: 0,
                path: '',
                descripcion: '',
                boletaMunicipalidadId: 0,
                preguntasId: 0,
                direccion:'',
                latitud: '',
                longitud: '',
                estadosId: 1
            },
            archivoCargado: false,
            dialogLoaderVisible:false,
            dialogLoaderText: 'Obteniendo información...',
            //Medios de verificacion de visita de campo
            tieneVisitaCampo: false,
            archivoVisitaMV:[],
            archivoVisitaMVValido:false,
            dialogRevisar: false,
            btnRegistroLoading: false,

            datosPreguntaSeleccionada: {
                id: 0,
                textoPregunta: '',
            },
            textoPregunta:'',
            datosMv: {
                direccion:'',
                latitud: '',
                longitud: '',

            },
           
            ...validations

        }

    },

    methods: {
        //!Obtener dato del municipio
        async obtenerDatosMunicipio(){
            
             await this.$store
            .dispatch(OBTENER_MUNICIPIO, this.municipioId)
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.nombreMunicipio = res.data.nombreMunicipio;
                }
                
            })
            .catch(err=> {
                console.log(err)
            });
        },

        //!Obtener boletas asignadas a la municipalidad con lo que se logueó
        async obtenerBoletasPorMuni(){
           
            this.boletas=[];
            //this.ddBoletasLoading=true;
            await this.$store
            .dispatch(OBTENER_BOLETAS_POR_MUNI_REVISOR_PERIODO, {idMuni:this.municipioId, idPeriodo: this.periodoId, idRevisor:  this.institucionId = this.currentUser.id} )
            .then(res => {
                if(res.status===200){
                    this.boletas=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddBoletasLoading=false;

                //console.log(this.boletas)
               
            }
            )
            .catch(() => {
                this.ddBoletasLoading=false;
                //console.warn(err)
            });
        },
       
           
    

        async obtenerPreguntasAsignadas(){

            //console.log(this.boletaSeleccionadaId)
            this.institucionId = this.currentUser.institucionesId;
            this.tableLoading=true;
            this.preguntas=[];
            await this.$store
            .dispatch(OBTENER_PREGUNTAS_POR_MUNICIPIO_PERIODO_INSTITUCION_REVISORA, {boletaMuniId: this.boletaSeleccionadaId.id, institucionId: this.institucionId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.preguntas = res.data;
                }
                 this.tableLoading=false;
            })
            .catch(err=> {
                this.tableLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas!';
                console.log(err)
            });


            
        },


        //!Obtener la estructura de una pregunta con sus respuestas y mostrar el modal, visitaCampo valida si la pregunta está sometida a visita de campo
        async obtenerEstructuraPregunta(boletaMuniId, preguntaId, visitaCampo){

            visitaCampo=="SI" ? this.tieneVisitaCampo = true : this.tieneVisitaCampo = false;
            this.dialogLoaderVisible=true;
            this.respuestasPreguntaSeleccionada=[];
            this.mediosPreguntaAsignados=[];
            this.preguntaSeleccionadaId = preguntaId;
            
            await this.$store
            .dispatch(OBTENER_PREGUNTA_POR_MUNICIPIO_PERIODO, {boletaMuniId: this.boletaSeleccionadaId.id, preguntaId: preguntaId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.respuestasPreguntaSeleccionada = res.data.respuestas;
                    this.textoPregunta = res.data.textoPregunta;


                     this.mediosPreguntaAsignados = res.data.listaMediosVerificacion;

                    this.obtenerMediosAsignadosPregunta(boletaMuniId, preguntaId);
                    this.obtenerMedioVisitaCampo();
                } else {
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `No se ha encontrado la pregunta seleccionada, por favor, si el problema persiste, ponte en contacto con un administrador del sistema.`);
                }
                 this.dialogLoaderVisible=false;
            })
            .catch(()=> {
                this.dialogLoaderVisible=false;
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `No se ha encontrado la pregunta seleccionada, por favor, si el problema persiste, ponte en contacto con un administrador del sistema.`);
                //console.log(err)
            });

            /////ESTO VA ADENTRO DEL RESPONSE 200
            this.dialogRevisar=true;
            //console.log(preguntaId)


            ////ESTO VA ADENTRO DEL RESPONSE 200 FIN
        },

        //!Obtener los medios asignados a la pregunta
        async  obtenerMediosAsignadosPregunta(boletaMuniId, preguntaId){
            
            this.mediosLoading=true;
            
            await this.$store
            .dispatch(OBTENER_MEDIOS_VERIFICACION_PREGUNTA_ESPECIFICA_MUNI, {boletaMuniId:boletaMuniId, preguntaId: preguntaId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                                       
                        this.mediosAsignados=res.data;

                        

                        let map = {};
                        for(var key of Object.keys(this.mediosAsignados)){
                            /* var element = {
                                 [this.respuestasRegistradas[key].respuestasId] : this.respuestasRegistradas[key].respuesta
                             }*/
                            

                             //console.log(element);
                             //map[key] = { [this.respuestasRegistradas[key].respuestasId]: this.respuestasRegistradas[key].respuesta}
                             let keyName = this.mediosAsignados[key].mediosVerificacionPreguntaId;
                             map[keyName] = this.mediosAsignados[key].path;

                           //  this.respuestasPregunta.push({[this.respuestasRegistradas[key].respuestasId] : this.respuestasRegistradas[key].respuesta});

                        }

                        this.mediosPregunta = map;

                       // console.log(this.mediosPregunta)


                    

                } /*else {
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                }*/
                 this.mediosLoading=false;
            })
            .catch(()=> {
                this.mediosLoading=false;
                //this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `No se han encontrado medios de verificación para la pregunta especificada, por favor, ponte en contacto con un administrador del sistema.`);
                //console.log(err)
            });
        },

        



        //!Se lanza cuando se hace click en una fila de la tabla de respuestas
        respuestasRowClick(row){
           // console.log(row)
            this.respuestaSeleccionada=row.id;
            //console.log(this.respuestaSeleccionada)
            this.selectedItem = row;

            if(row.valor.length > 0 && row.tipoDatoId !=3){
                this.datosRevision.boletaMunicipalidadId = row.valor[0].boletaMunicipalidadId;
                this.datosRevision.respuestasMuniId = row.valor[0].id;
                this.obtenerHistorialRevisionesRespuesta(this.datosRevision.respuestasMuniId);
            }
            else {
                this.datosRevision.boletaMunicipalidadId = 0;
            }

            //console.log(this.datosRevision.boletaMunicipalidadId)
            /*this.textoRespuestaActual = row.textoRespuesta;
            this.datosValidacion.respuestasId = row.id;
            this.obtenerValidacionesRespuesta(row.id);*/
        },

        //!Obtener el hisorial de revisiones por respuesta
        async obtenerHistorialRevisionesRespuesta(respuestaMuniId){
            
            this.tableRevisionesLoading=true;
            this.historialRevisiones=[];
            this.agregarRevision=true;
            await this.$store
            .dispatch(OBTENER_HISTORIAL_REVISIONES_RESPUESTA, respuestaMuniId)
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.historialRevisiones = res.data;
                    //!Recorrer el historial de revisiones para validar que exista un APROBADO, de ser así, se bloquea el registro de una nueva aprobación
                    this.historialRevisiones.forEach(historial=>{
                        //console.log(historial)
                        if(historial.estadosAprobacionId===1){
                            this.agregarRevision=false;
                        }
                    })
                }
                 this.tableRevisionesLoading=false;
            })
            .catch(err=> {
                this.tableRevisionesLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas!';
                console.log(err)
            });
        },

        //!Registrar historial de revision para una respuesta
        async registrarRevision(){
            //console.log(this.datosRevision);

            if(this.datosRevision.estadosRevisionAprobacionId===1){
                this.datosRevision.descripcionInconsistencia='';
            }

            this.btnRegistroLoading=true;
           
            let respuestaMuniId = this.datosRevision.respuestasMuniId;
            await this.$store
            .dispatch(REGISTRAR_HISTORIAL_REVISION_RESPUESTA, this.datosRevision)
            .then(res => {
                //console.log(res)
                if(res.status===200){
                   // console.log(res)
                    this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                    this.obtenerHistorialRevisionesRespuesta(this.datosRevision.respuestasMuniId)
                    this.datosRevision.estadosRevisionAprobacionId=0;
                    this.datosRevision.descripcionInconsistencia ='';
                    this.datosRevision.noRevision=0;
                    this.datosRevision.estadosId=1;
                    this.datosRevision.respuestasMuniId = respuestaMuniId;
                    this.datosRevision.boletaMunicipalidadId =  this.datosRevision.boletaMunicipalidadId;
                } else {
                    this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', res.message);
                }
                 this.btnRegistroLoading=false;
            })
            .catch(err=> {
                this.btnRegistroLoading=false;
                this.$refs.snackalert.SnackbarShow('success', 'Mensaje', `Ha ocurrido un error durante la operacion, por favor, ponte en contacto con un administrador del sistema. REF: ${err}`);
            });
        },

        //!Descargar el archivo de medio de verificación
        descargarArchivo(path){
        // console.log(path)
            window.open(path, "_blank");
        },



        //!Validar el archivo que se carga para cada medio de verificación
        onFileChange(e, controlId){
            //console.log(e);
            //console.log(medioVerificacionId)
        // console.log("aqui")
            if(e){
                //!?Validar que el tipo de archivo sea pdf
                if (e.type != "application/pdf" && e.type != "image/jpeg" ){
                    // Api call
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `El archivo que desea ingresar no es válido.`);
                    //console.log("no es un pdf..")
                    //this.$refs.file.reset();
                    //this.$refs.mvFile.reset();
                    //document.querySelector('#'+controlId).value = null;
                    
                    //this.$refs[controlId][0].reset();
                    //this.$refs[controlId].value=null;
                    this.archivoVisitaMV=null;
                    this.archivoVisitaMV=[];
                    this.archivoVisitaMV=[];
                    this.archivoVisitaMVValido=false;
                    
                    this.$refs[controlId][0].reset();
                    return false;
                }
                //?Validar que el tamaó del archivo no exceda los 5Mb
                else if ((e.size/1024/1024) > 25){
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `El tamaño del archivo excede el límite permitido (25Mb)`);
                    // this.$refs.file.reset();
                    //this.$refs.mvFile.reset();
                // document.querySelector('#'+controlId).value = null;
                    //this.$refs.mvFile.value=null;
                    
                    this.archivoVisitaMV=null;
                    this.archivoVisitaMV=[];
                    this.archivoVisitaMV=[];
                    this.archivoVisitaMVValido=false;
                    
                    this.$refs[controlId][0].reset();
                    //this.$refs[controlId].value=null;

                    return false;
                } else {
                    this.archivoVisitaMVValido = true;
                    this.archivoVisitaMV = e;
                // console.log(this.archivoMV)
                }
                
            } else {
                this.archivoVisitaMVValido=false;
            }
        },


        //!Obtener el archivo de medio de verificacion correspondiente a la visita de campo para la pregunta
        async obtenerMedioVisitaCampo(){

            
            this.tableRevisionesLoading=true;
            this.datosVisitaCampo=[];
            await this.$store
            .dispatch(OBTENER_VISITA_CAMPO_PREGUNTA, {boletaMuniId: this.boletaSeleccionadaId.id, preguntaId: this.preguntaSeleccionadaId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.datosVisitaCampo = res.data;
                    this.visitaCampoRegistrada=true;
                } else{

                    this.visitaCampoRegistrada=false;
                }
                 this.tableRevisionesLoading=false;
            })
            .catch(err=> {
                this.tableRevisionesLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas!';
                console.log(err)
            });
        },



 
        //!Registrar el medio de verificación de visita de campo
        guardarMedio(){

            this.dialogLoaderVisible=true;
            this.dialogLoaderText='Almacenando medio de verificación...';

            //this.datosMedio.boletaMunicipalidadId = this.boletaMunicipalidadId;
            //this.datosMedio.mediosVerificacionPreguntaId= medioVerificacionPreguntaId;
            //this.datosMedio.nombreArchivo=this.archivoMV.name;

        // console.log(this.archivoMV);
            if(this.archivoVisitaMV!= null){
                //Cargar Archivo de medio de verificacion en el server
                this.cargarMV()
                .then(() => {
                
                    //?Validar que el archivo fue cargado
                    if(this.archivoCargado){

                        this.dialogLoaderText='Registrando medio de verificación...';
                        this.registrarVisitaCampoPregunta();
                        
                    } else {
                        this.dialogLoaderVisible=false;
                    }
                })
                .catch(() => {
                    this.dialogLoaderVisible=false;
                }); 
            } else {
                this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `No se ha seleccionado un archivo válido, por favor inténtalo de nuevo, si el problema persiste, ponte en contacto con un administrador del sistema`);
                this.dialogLoaderVisible=false;
            }

        },


         //!Cargar el archivo de medio de verificación para la visita de campo pregunta
        async cargarMV(){
            
            const file = this.archivoVisitaMV;

                await 
                this.$store.dispatch(CARGAR_ARCHIVO, {file:file, path: '\\documentos\\municipalidades\\revision\\visitacampo\\mediosverificaion\\'})
                .then(res => {
                    //console.log(res)
                    if(res.status===200){
                        this.archivoCargado = true;
                        this.datosVisita.path = res.pathArchivo;
                        return true;
                    }
                    else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        this.archivoCargado = false;
                        return false;
                    }
                })
                .catch(() => {
                    //console.log(error)
                    return false;
                    
                });
            },



        //!Registrar una visita de campo para la pregunta
        async registrarVisitaCampoPregunta(){
            

            this.datosVisita.preguntasId = this.preguntaSeleccionadaId;
            this.datosVisita.boletaMunicipalidadId = this.boletaSeleccionadaId.id;
            //this.datosVisita.path = "testpath";
            this.datosVisita.descripcion = "testdesc";
            
             await this.$store
            .dispatch(REGISTRAR_VISITA_CAMPO_PREGUNTA, this.datosVisita)
            .then(res => {
                console.log(res)
                if(res.status===200){
                   // console.log(res)
                   this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                   this.resetMvFile();
                   this.obtenerMedioVisitaCampo();
                   
                } else {
                    this.$refs.snackalert.SnackbarShow('warning', 'Mensaje', res.message);
                }
                 this.btnRegistroLoading=false;
                 this.dialogLoaderVisible=false;
            })
            .catch(err=> {
                this.btnRegistroLoading=false;
                this.$refs.snackalert.SnackbarShow('success', 'Mensaje', `Ha ocurrido un error durante la operacion, por favor, ponte en contacto con un administrador del sistema. REF: ${err}`);
            });
        },


        //!Realizar el reset del fileinput
        resetMvFile(){
            this.archivoCargado=false;   
            this.archivoVisitaMV=[];
            this.datosVisita={
                id: 0,
                path: '',
                descripcion: '',
                boletaMunicipalidadId: 0,
                preguntasId: 0,
                direccion:'',
                latitud: '',
                longitud: '',
                estadosId: 1
            },
            this.$refs.mvFile.reset();
        }
    },

    created(){
        this.baseIntUrl = API_BASE_URL;

        this.parameters = this.$route.params;
        if(this.parameters.municipalidadId && this.parameters.periodoId){
            this.periodoId = this.parameters.periodoId;
            this.municipioId = this.parameters.municipalidadId;
        }

        this.obtenerDatosMunicipio();

        
    },

    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Inicio", route: "/dashboard-revisor-aprobador" },
            { title: "Revisión" },
            { title: "Preguntas" }
        ]);

        this.obtenerBoletasPorMuni();
        //this.obtenerPreguntasAsignadas();


    },

    computed:{

        ...mapGetters(["currentUser"]),

         headers() {
            return [
                
                {
                    text: "# Orden",
                    value: "noOrdenPregunta"
                },
                {
                    text: "Indice",
                    align: "start",
                    sortable: true,
                    value: "Indice"
                },
                {
                    text: "Pregunta",
                    value: "textoPregunta"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        },


         respuestasHeaders() {
            return [
                {
                    text: "Respuesta",
                    align: "start",
                    sortable: false,
                    value: "textoRespuesta",
                    class:"custom-header-color"
                },
                 {
                    text: "Valor",
                    align: "start",
                    sortable: false,
                    value: "valorRespuesta",
                    class:"custom-header-color"
                },
            ]
         },

         revisionesHeaders(){
            return [
                 {
                    text: "Fecha",
                    align: "start",
                    sortable: false,
                    value: "fechaCreacion",
                    class:"custom-header-color"
                },
                {
                    text: "Tipo",
                    align: "start",
                    sortable: false,
                    value: "tipo",
                    class:"custom-header-color"
                },
                {
                    text: "Estado",
                    align: "start",
                    sortable: false,
                    value: "estado",
                    class:"custom-header-color"
                },
                 {
                    text: "Comentario de inconsistencia",
                    align: "start",
                    sortable: false,
                    value: "descripcionInconsistencia",
                    class:"custom-header-color"
                },
            ]  
         }
    }

}
</script>
<style lang="scss">
    
.selectedRow {
    background-color: #eeeeee;
    border-left: 4px solid #009688;
}

.hoverRow:hover{
    cursor: pointer;
}

.custom-header-color{
    background-color: #b0b4c2;
    border-bottom: 1px solid #7c808c !important;
}

.current{
    background-color: #40d7a1;
    border-left: 2px inset black;
}

.current-desaprobado{
    background-color: #ebbc77;
    border-left: 2px inset rgb(165, 77, 5);
}

.current:hover{
    background-color: #40d7a1 !important;
}
</style>